<template>
  <div id="app">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key"/>
    </transition>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";

export default {
  name: 'app',
  data() {
    return {}
  },
  computed: {
    key() {
      return this.$route.path
    },
    ...mapGetters([
      'urlName'
    ])
  },
  methods:{
    ...mapMutations(['SET_URL_NAME'])
  },
  created() {
    if (this.urlName === '') {
      this.SET_URL_NAME('index')
    }
  }
}
</script>

<style scoped lang="less">
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all .5s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

</style>
